import request from '@/utils/request'

// 查询种植记录分页
export function pagePlantRecord(data) {
  return request({
    url: '/cloudplant/plantRecord/page',
    method: 'post',
    data: data
  })
}

// 查询种植记录详情
export function getPlantRecord(data) {
  return request({
    url: '/cloudplant/plantRecord/detail',
    method: 'get',
    params: data
  })
}
